export const ADMIN_ROUTES = {
  index: {
    path: 'admin/*',
    to: '/admin/interface',
  },
  interface: {
    path: 'admin/interface',
    to: '/interface',
  },
  organizations: {
    path: 'admin/*',
    to: '/admin/organizations',
  },

  map_overlay: {
    path: 'admin/*',
    to: '/admin/interface/map_overlay_site',
  },
  dynamicSchemaConfig: {
    path: '/dynamic-schema',
    to: '/admin/dynamic-schema',
    detail: {
      path: '/dynamic-schema/:id',
      to: '/admin/dynamic-schema/:id',
    },
  },
  telemetryHub: {
    path: '/telemetry-hub',
    to: '/admin/telemetry-hub',
  },
}

